import * as React from 'react';
import {useState} from 'react';
import MuiCard from '@mui/material/Card';
import {styled} from '@mui/material/styles';
import CartManager, {useCartChange} from "../../../managers/cartManager/cartManager";
import {validateUserInfo} from "../../../managers/cartManager/validators/userInfoValidator";
import InvoiceDataEditor from "./InvoiceDataEditor";

export const StyledMuiCard = styled(MuiCard)(({theme}) => ({
    border: '1px solid',
    borderColor: (theme.vars || theme).palette.divider,
    width: '100%',
    '&:hover': {
        background:
            'linear-gradient(to bottom right, hsla(210, 100%, 97%, 0.5) 25%, hsla(210, 100%, 90%, 0.3) 100%)',
        borderColor: 'primary.light',
        boxShadow: '0px 2px 8px hsla(0, 0%, 0%, 0.1)',
        ...theme.applyStyles('dark', {
            background:
                'linear-gradient(to right bottom, hsla(210, 100%, 12%, 0.2) 25%, hsla(210, 100%, 16%, 0.2) 100%)',
            borderColor: 'primary.dark',
            boxShadow: '0px 1px 8px hsla(210, 100%, 25%, 0.5) ',
        }),
    },
    [theme.breakpoints.up('md')]: {
        flexGrow: 1,
        maxWidth: `calc(50% - ${theme.spacing(1)})`,
    },
    variants: [
        {
            props: ({selected}) => selected,
            style: {
                borderColor: (theme.vars || theme).palette.primary.light,
                ...theme.applyStyles('dark', {
                    borderColor: (theme.vars || theme).palette.primary.dark,
                }),
            },
        },
    ],
}));

function UserInfo() {
    const cart = useCartChange();
    const [dataFormValidity, setDataFormValidity] = useState({});

    const setInvoiceData = (newInvoiceData) => {
        const userInfo = newInvoiceData.userInfo;
        const personType = newInvoiceData.type;
        CartManager.changeInvoiceDataType(personType);
        CartManager.changeUserInfo(userInfo);
    }

    return (
        <InvoiceDataEditor invoiceData={cart?.invoiceData || {type: (CartManager.getPersonType() || UserInfo.types.NATURAL_PERSON), userInfo: {}}}
                                    setInvoiceData={setInvoiceData}
                                    dataFormValidity={dataFormValidity}
                                    setDataFormValidity={setDataFormValidity}/>
    );
}

UserInfo.types = class Types {
    static get NATURAL_PERSON() {
        return 'natural'
    }

    static get JURIDICAL_PERSON() {
        return 'juridical'
    }
}

export const validateInvoiceData = (invoiceData, hasUser) => {
    const doNotValidate = {};
    if (hasUser) {
        doNotValidate.email = true;
    }

    if (invoiceData.type === UserInfo.types.NATURAL_PERSON) {
        doNotValidate.firmName = true;
        doNotValidate.vatNr = true;
    }

    return validateUserInfo(invoiceData.userInfo, doNotValidate);
}

export default UserInfo;